import { NavigateOptions, useNavigate, useSearchParams } from 'react-router-dom';

export const useNavigateParams = () => {
    const navigateRRD = useNavigate();
    const [searchParams] = useSearchParams();

    const navigate = (to: string, options?: NavigateOptions) => {
        if (searchParams.toString()) {
            navigateRRD(`${to}?${searchParams.toString()}`, options);
            return;
        }

        navigateRRD(to, options);
    };

    return { navigate };
};
